<section class="login-redirect">
    <div class="loader">
        <i class="fa-solid fa-spinner fa-5x fa-spin"></i>
        <p class="text-center mt-3 mb-0">You will be redirected shortly....</p>

    </div>
</section>


<!-- :: AUTH RENEW MODAL :: -->
<!-- :: AUTH RENEW MODAL :: -->
<app-modal #AuthRenewModal [size]="'md'">
    <ng-container modal-header>
        <div class="d-flex align-items-center justify-content-start p-2">
            <h5 class="m-0">Session Expired</h5>
        </div>
    </ng-container>
    <ng-container modal-body>
        <div class="d-flex align-items-center justify-content-between p-2">
            <div>
                <p class="modal-text">Your session has expired, please log back in.</p>
            </div>
            <div>
                <button class="nav-item" (click)="auth_modal_close()">
                    <a class="nav-link" href="/login">LOGIN</a>
                </button>
            </div>
        </div>
    </ng-container>
    <!-- <ng-container modal-footer> -->
    <!-- </ng-container> -->
</app-modal>
<!-- :: AUTH RENEW MODAL :: -->
<!-- :: AUTH RENEW MODAL :: -->